import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';

// Dynamically load media from a folder using Webpack's require.context
const mediaContext = require.context('./media', false, /\.(png|jpe?g|mp4|webm)$/); // Update extensions as needed
const mediaFiles = mediaContext.keys().map((key) => mediaContext(key));

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

const FullScreenCarousel = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '100vh',
          height: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transform: 'rotate(270deg)',
          transformOrigin: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <Slider {...settings}>
            {mediaFiles.map((src, index) => {
              const isVideo = src.endsWith('.mp4') || src.endsWith('.webm');
              return isVideo ? (
                <Box
                  key={index}
                  component="video"
                  src={src}
                  autoPlay

                  muted
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'fill',
                  }}
                />
              ) : (
                <Box
                  key={index}
                  component="img"
                  src={src}
                  alt={`Media ${index + 1}`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'fill',
                  }}
                />
              );
            })}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default FullScreenCarousel;
